import React from 'react';
import Loader from "react-js-loader";


const CircleLoader = () => {
    return (
        <Loader
            type="spinner-cub"
            bgColor={"#2e55fa"}
            title={"bubble-top"}
            color={'#FFFFFF'}
            size={100}
        />
    );
};

export default CircleLoader;